"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllTokenBurnResponseV202 = exports.QueryAllTokenBurnResponse = exports.QueryAllTokenBurnRequest = exports.QueryGetTokenBurnResponseV202 = exports.QueryGetTokenBurnResponse = exports.QueryGetTokenBurnRequest = exports.QueryBurnsResponseV202 = exports.QueryBurnsResponse = exports.QueryBurnsRequest = exports.QueryGetOptionsResponse = exports.QueryGetOptionsRequest = exports.QueryAllMintpermResponse = exports.QueryAllMintpermRequest = exports.QueryGetMintpermResponse = exports.QueryGetMintpermRequest = exports.QueryAllTokenResponse = exports.QueryAllTokenRequest = exports.QueryGetTokenResponse = exports.QueryGetTokenRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = require("protobufjs/minimal");
const params_1 = require("./params");
const token_1 = require("./token");
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const mintperm_1 = require("./mintperm");
const options_1 = require("./options");
const burn_1 = require("./burn");
const token_burn_1 = require("./token_burn");
exports.protobufPackage = "thesixnetwork.sixprotocol.tokenmngr";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryGetTokenRequest = { name: "" };
exports.QueryGetTokenRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenRequest);
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenRequest);
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        return message;
    },
};
const baseQueryGetTokenResponse = {};
exports.QueryGetTokenResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.token !== undefined) {
            token_1.Token.encode(message.token, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = token_1.Token.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenResponse);
        if (object.token !== undefined && object.token !== null) {
            message.token = token_1.Token.fromJSON(object.token);
        }
        else {
            message.token = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined &&
            (obj.token = message.token ? token_1.Token.toJSON(message.token) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenResponse);
        if (object.token !== undefined && object.token !== null) {
            message.token = token_1.Token.fromPartial(object.token);
        }
        else {
            message.token = undefined;
        }
        return message;
    },
};
const baseQueryAllTokenRequest = {};
exports.QueryAllTokenRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllTokenResponse = {};
exports.QueryAllTokenResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.token) {
            token_1.Token.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.token = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token.push(token_1.Token.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.token = [];
        if (object.token !== undefined && object.token !== null) {
            for (const e of object.token) {
                message.token.push(token_1.Token.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token) {
            obj.token = message.token.map((e) => (e ? token_1.Token.toJSON(e) : undefined));
        }
        else {
            obj.token = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.token = [];
        if (object.token !== undefined && object.token !== null) {
            for (const e of object.token) {
                message.token.push(token_1.Token.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetMintpermRequest = { token: "", address: "" };
exports.QueryGetMintpermRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMintpermRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMintpermRequest);
        if (object.token !== undefined && object.token !== null) {
            message.token = String(object.token);
        }
        else {
            message.token = "";
        }
        if (object.address !== undefined && object.address !== null) {
            message.address = String(object.address);
        }
        else {
            message.address = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined && (obj.token = message.token);
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMintpermRequest);
        if (object.token !== undefined && object.token !== null) {
            message.token = object.token;
        }
        else {
            message.token = "";
        }
        if (object.address !== undefined && object.address !== null) {
            message.address = object.address;
        }
        else {
            message.address = "";
        }
        return message;
    },
};
const baseQueryGetMintpermResponse = {};
exports.QueryGetMintpermResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.mintperm !== undefined) {
            mintperm_1.Mintperm.encode(message.mintperm, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMintpermResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintperm = mintperm_1.Mintperm.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMintpermResponse);
        if (object.mintperm !== undefined && object.mintperm !== null) {
            message.mintperm = mintperm_1.Mintperm.fromJSON(object.mintperm);
        }
        else {
            message.mintperm = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.mintperm !== undefined &&
            (obj.mintperm = message.mintperm
                ? mintperm_1.Mintperm.toJSON(message.mintperm)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMintpermResponse);
        if (object.mintperm !== undefined && object.mintperm !== null) {
            message.mintperm = mintperm_1.Mintperm.fromPartial(object.mintperm);
        }
        else {
            message.mintperm = undefined;
        }
        return message;
    },
};
const baseQueryAllMintpermRequest = {};
exports.QueryAllMintpermRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMintpermRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMintpermRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMintpermRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllMintpermResponse = {};
exports.QueryAllMintpermResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.mintperm) {
            mintperm_1.Mintperm.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMintpermResponse);
        message.mintperm = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mintperm.push(mintperm_1.Mintperm.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMintpermResponse);
        message.mintperm = [];
        if (object.mintperm !== undefined && object.mintperm !== null) {
            for (const e of object.mintperm) {
                message.mintperm.push(mintperm_1.Mintperm.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.mintperm) {
            obj.mintperm = message.mintperm.map((e) => e ? mintperm_1.Mintperm.toJSON(e) : undefined);
        }
        else {
            obj.mintperm = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMintpermResponse);
        message.mintperm = [];
        if (object.mintperm !== undefined && object.mintperm !== null) {
            for (const e of object.mintperm) {
                message.mintperm.push(mintperm_1.Mintperm.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetOptionsRequest = {};
exports.QueryGetOptionsRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOptionsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryGetOptionsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryGetOptionsRequest);
        return message;
    },
};
const baseQueryGetOptionsResponse = {};
exports.QueryGetOptionsResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.Options !== undefined) {
            options_1.Options.encode(message.Options, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOptionsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Options = options_1.Options.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetOptionsResponse);
        if (object.Options !== undefined && object.Options !== null) {
            message.Options = options_1.Options.fromJSON(object.Options);
        }
        else {
            message.Options = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.Options !== undefined &&
            (obj.Options = message.Options
                ? options_1.Options.toJSON(message.Options)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetOptionsResponse);
        if (object.Options !== undefined && object.Options !== null) {
            message.Options = options_1.Options.fromPartial(object.Options);
        }
        else {
            message.Options = undefined;
        }
        return message;
    },
};
const baseQueryBurnsRequest = {};
exports.QueryBurnsRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBurnsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryBurnsRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryBurnsRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryBurnsResponse = {};
exports.QueryBurnsResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.Burn) {
            burn_1.Burn.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBurnsResponse);
        message.Burn = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Burn.push(burn_1.Burn.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryBurnsResponse);
        message.Burn = [];
        if (object.Burn !== undefined && object.Burn !== null) {
            for (const e of object.Burn) {
                message.Burn.push(burn_1.Burn.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.Burn) {
            obj.Burn = message.Burn.map((e) => (e ? burn_1.Burn.toJSON(e) : undefined));
        }
        else {
            obj.Burn = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryBurnsResponse);
        message.Burn = [];
        if (object.Burn !== undefined && object.Burn !== null) {
            for (const e of object.Burn) {
                message.Burn.push(burn_1.Burn.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryBurnsResponseV202 = {};
exports.QueryBurnsResponseV202 = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.Burn) {
            burn_1.BurnV202.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBurnsResponseV202);
        message.Burn = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Burn.push(burn_1.BurnV202.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryBurnsResponseV202);
        message.Burn = [];
        if (object.Burn !== undefined && object.Burn !== null) {
            for (const e of object.Burn) {
                message.Burn.push(burn_1.BurnV202.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.Burn) {
            obj.Burn = message.Burn.map((e) => (e ? burn_1.BurnV202.toJSON(e) : undefined));
        }
        else {
            obj.Burn = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryBurnsResponseV202);
        message.Burn = [];
        if (object.Burn !== undefined && object.Burn !== null) {
            for (const e of object.Burn) {
                message.Burn.push(burn_1.BurnV202.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetTokenBurnRequest = { token: "" };
exports.QueryGetTokenBurnRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenBurnRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnRequest);
        if (object.token !== undefined && object.token !== null) {
            message.token = String(object.token);
        }
        else {
            message.token = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined && (obj.token = message.token);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnRequest);
        if (object.token !== undefined && object.token !== null) {
            message.token = object.token;
        }
        else {
            message.token = "";
        }
        return message;
    },
};
const baseQueryGetTokenBurnResponse = {};
exports.QueryGetTokenBurnResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.tokenBurn !== undefined) {
            token_burn_1.TokenBurn.encode(message.tokenBurn, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenBurnResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenBurn = token_burn_1.TokenBurn.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnResponse);
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            message.tokenBurn = token_burn_1.TokenBurn.fromJSON(object.tokenBurn);
        }
        else {
            message.tokenBurn = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenBurn !== undefined &&
            (obj.tokenBurn = message.tokenBurn
                ? token_burn_1.TokenBurn.toJSON(message.tokenBurn)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnResponse);
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            message.tokenBurn = token_burn_1.TokenBurn.fromPartial(object.tokenBurn);
        }
        else {
            message.tokenBurn = undefined;
        }
        return message;
    },
};
const baseQueryGetTokenBurnResponseV202 = {};
exports.QueryGetTokenBurnResponseV202 = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.tokenBurn !== undefined) {
            token_burn_1.TokenBurnV202.encode(message.tokenBurn, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenBurnResponseV202);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenBurn = token_burn_1.TokenBurnV202.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnResponseV202);
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            message.tokenBurn = token_burn_1.TokenBurnV202.fromJSON(object.tokenBurn);
        }
        else {
            message.tokenBurn = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tokenBurn !== undefined &&
            (obj.tokenBurn = message.tokenBurn
                ? token_burn_1.TokenBurnV202.toJSON(message.tokenBurn)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenBurnResponseV202);
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            message.tokenBurn = token_burn_1.TokenBurnV202.fromPartial(object.tokenBurn);
        }
        else {
            message.tokenBurn = undefined;
        }
        return message;
    },
};
const baseQueryAllTokenBurnRequest = {};
exports.QueryAllTokenBurnRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenBurnRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllTokenBurnResponse = {};
exports.QueryAllTokenBurnResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.tokenBurn) {
            token_burn_1.TokenBurn.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenBurnResponse);
        message.tokenBurn = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenBurn.push(token_burn_1.TokenBurn.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnResponse);
        message.tokenBurn = [];
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            for (const e of object.tokenBurn) {
                message.tokenBurn.push(token_burn_1.TokenBurn.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenBurn) {
            obj.tokenBurn = message.tokenBurn.map((e) => e ? token_burn_1.TokenBurn.toJSON(e) : undefined);
        }
        else {
            obj.tokenBurn = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnResponse);
        message.tokenBurn = [];
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            for (const e of object.tokenBurn) {
                message.tokenBurn.push(token_burn_1.TokenBurn.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllTokenBurnResponseV202 = {};
exports.QueryAllTokenBurnResponseV202 = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.tokenBurn) {
            token_burn_1.TokenBurnV202.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenBurnResponseV202);
        message.tokenBurn = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenBurn.push(token_burn_1.TokenBurnV202.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnResponseV202);
        message.tokenBurn = [];
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            for (const e of object.tokenBurn) {
                message.tokenBurn.push(token_burn_1.TokenBurnV202.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenBurn) {
            obj.tokenBurn = message.tokenBurn.map((e) => e ? token_burn_1.TokenBurnV202.toJSON(e) : undefined);
        }
        else {
            obj.tokenBurn = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenBurnResponseV202);
        message.tokenBurn = [];
        if (object.tokenBurn !== undefined && object.tokenBurn !== null) {
            for (const e of object.tokenBurn) {
                message.tokenBurn.push(token_burn_1.TokenBurnV202.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.Reader(data)));
    }
    Token(request) {
        const data = exports.QueryGetTokenRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "Token", data);
        return promise.then((data) => exports.QueryGetTokenResponse.decode(new minimal_1.Reader(data)));
    }
    TokenAll(request) {
        const data = exports.QueryAllTokenRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "TokenAll", data);
        return promise.then((data) => exports.QueryAllTokenResponse.decode(new minimal_1.Reader(data)));
    }
    Mintperm(request) {
        const data = exports.QueryGetMintpermRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "Mintperm", data);
        return promise.then((data) => exports.QueryGetMintpermResponse.decode(new minimal_1.Reader(data)));
    }
    MintpermAll(request) {
        const data = exports.QueryAllMintpermRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "MintpermAll", data);
        return promise.then((data) => exports.QueryAllMintpermResponse.decode(new minimal_1.Reader(data)));
    }
    Options(request) {
        const data = exports.QueryGetOptionsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "Options", data);
        return promise.then((data) => exports.QueryGetOptionsResponse.decode(new minimal_1.Reader(data)));
    }
    Burns(request) {
        const data = exports.QueryBurnsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "Burns", data);
        return promise.then((data) => exports.QueryBurnsResponse.decode(new minimal_1.Reader(data)));
    }
    BurnsV202(request) {
        const data = exports.QueryBurnsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "BurnsV202", data);
        return promise.then((data) => exports.QueryBurnsResponseV202.decode(new minimal_1.Reader(data)));
    }
    TokenBurn(request) {
        const data = exports.QueryGetTokenBurnRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "TokenBurn", data);
        return promise.then((data) => exports.QueryGetTokenBurnResponse.decode(new minimal_1.Reader(data)));
    }
    TokenBurnV202(request) {
        const data = exports.QueryGetTokenBurnRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "TokenBurnV202", data);
        return promise.then((data) => exports.QueryGetTokenBurnResponseV202.decode(new minimal_1.Reader(data)));
    }
    TokenBurnAll(request) {
        const data = exports.QueryAllTokenBurnRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "TokenBurnAll", data);
        return promise.then((data) => exports.QueryAllTokenBurnResponse.decode(new minimal_1.Reader(data)));
    }
    TokenBurnAllV202(request) {
        const data = exports.QueryAllTokenBurnRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixprotocol.tokenmngr.Query", "TokenBurnAllV202", data);
        return promise.then((data) => exports.QueryAllTokenBurnResponseV202.decode(new minimal_1.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map